import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import infoIcon from 'images/utility-icons/tooltip-icon.svg';
/**
 * Light blue informational callout with a leading info icon. Reusable across
 * apps for surfacing tips, notes, and non-error messages.
 */
function InfoBox({ children, className = '' }) {
    return (_jsxs("div", { className: `info-callout ${className}`.trim(), children: [_jsx("img", { src: infoIcon, alt: "", "aria-hidden": "true", className: "info-callout__icon" }), _jsx("div", { className: "info-callout__content", children: children })] }));
}
export default InfoBox;
